<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >place</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.canton' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->

      <button mat-raised-button
        [routerLink]="'/pages/canton/new'"
        class="add-product-button mat-white-bg my-12 mt-sm-0">
        <span>{{'canton.add_new_canton' | translate}}</span>
      </button>
      <button mat-button class="mat-icon-button sidenav-toggle ml-12"
        fuseMatSidenavToggler="sidenav"
        fxHide.gt-lg>
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
    <!-- / HEADER -->


    <mat-sidenav-container class="my-sidenav" style="  position: absolute;
    width: 210px;
    height: calc(100vh - 210px);
    right: 0;
    z-index: 999;
    top: 136px;
    background: transparent;">
      <mat-sidenav #sidenav class="sidenav mat-sidenav-opened" position="end" opened="true" mode="side"
                   fuseMatSidenavHelper="sidenav" mat-is-locked-open="gt-sm" [ngClass]="{'hide-menu': !sidenav.opened}" style="    position: absolute;
    width: 100%;
    margin: 0px;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    overflow: hidden;
    transform: none;
    visibility: visible;">
        <filter-menu [filters]="filterData" [page]="'canton'" [filterFromDB]="userFilters"
        (chooseFilter)="chooseFilters($event)"></filter-menu>
      </mat-sidenav>
    </mat-sidenav-container>

    <!-- CONTENT CARD -->
    <!--<mat-sidenav-container class="my-sidenav"  style="  position: absolute;-->
    <!--width: 210px;-->
    <!--height: calc(100vh - 210px);-->
    <!--right: 0;-->
    <!--z-index: 999;-->
    <!--top: 136px;-->
    <!--background: white;">-->
      <!--<mat-sidenav #sidenav class="sidenav mat-sidenav-opened" position="end" opened="true" mode="side"-->
                   <!--fuseMatSidenavHelper="sidenav" [ngClass]="{'hide-menu': !sidenav.opened}" style="    position: absolute;-->
    <!--width: 100%;-->
    <!--margin: 0px;-->
    <!--display: flex;-->
    <!--flex: 1 1 0%;-->
    <!--flex-direction: column;-->
    <!--overflow: hidden;-->
    <!--transform: none;-->
    <!--visibility: visible;">-->
        <!--<filter-menu [filters]="filterData" [page]="'canton'" [filterFromDB]="userFilters"-->
                     <!--(chooseFilter)="chooseFilters($event)"></filter-menu>-->
      <!--</mat-sidenav>-->
    <!--</mat-sidenav-container>-->

    <div class="content-card mat-white-bg"
         [ngClass]="{'margin-big-screen': sidenav.opened}">

  <mat-table class="products-table"
    #table [dataSource]="cantons"
    matSort
    [@animateStagger]="{value:'50'}"
    fusePerfectScrollbar>


    <!-- Name Column -->
    <ng-container cdkColumnDef="name">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let canton">
        <p class="text-truncate">{{canton.name}}</p>
      </mat-cell>
    </ng-container>
    <!-- Image Column -->
    <ng-container cdkColumnDef="image">
      <mat-header-cell *cdkHeaderCellDef></mat-header-cell>
      <mat-cell *cdkCellDef="let canton">
        @if (canton.flag) {
          <img class="canton-image"
            [alt]="canton.name"
            [src]="getImage(canton.flag)"/>
        }
        @if (!canton.flag) {
          <img class="product-image" [src]="'assets/images/district_black.svg'">
        }
      </mat-cell>
    </ng-container>

    <!-- Code Column -->
    <ng-container cdkColumnDef="code">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.code' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let canton">
        <p class="text-truncate">{{canton.code}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="country">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.country' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let canton">
        <img style="height: 40px" [src]="'assets/images/' + canton.country.flag + '.svg'"/>
      </mat-cell>
    </ng-container>


    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *cdkRowDef="let canton; columns: displayedColumns;"
      class="product"
      matRipple
      [routerLink]="'/pages/canton/detail'" [queryParams]="{id: canton.id}">
    </mat-row>

  </mat-table>
  @if (cantons.filteredData.length === 0) {
    <div class="no-data-msg">
      <span class="mat-headline-6">{{'main.noData' | translate}}</span>
    </div>
  }
  <mat-paginator #paginator
    [length]="cantons.filteredData.length"
    [pageIndex]="0"
    [pageSize]="50"
    [pageSizeOptions]="[25, 50, 100]">
  </mat-paginator>

</div>
<!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>



